import React from 'react'

import style from './style'
import { func, object, array, string, number, shape } from 'prop-types'

import InputSetting from './InputSetting'
import CopySetting from './CopySetting'
import MethodButtons from './SettingButtons/MethodButtons'
import RangeButtons from './SettingButtons/RangeButtons'
import ActButtons from './SettingButtons/ActButtons'
import ScopeSetting from './ScopeSetting'
import Grid from './Grid'

import range from 'lodash/range'

function RangeEditor (props) {
  const {
    updateScopeAndGridValues, updateUsing, clickCell, updateGridValues, undo, extendRange, save,
    page: { gotoDocList }, using, ranges, scope, gridValues,
  } = props
  const { cMax, cMin, interval } = scope
  const { rangeKey, method } = using

  return (
    <div>
      <div className={style['fixed-on-top']}>
        <h3 className={style.pageTitle} style={{ marginTop: 20 }}>鏡片資料管理</h3>
        <div style={{ width: 1000, height: 60 }}>
          <RangeButtons {...{ using: rangeKey, ranges, updateUsing, style }} />
        </div>
        <div className={style['sets-container']}>
          <div style={{ float: 'left' }}>
            <MethodButtons {...{ updateUsing, using: method, style }} />
          </div>
          <div style={{ float: 'right' }}>
            <ActButtons {...{ updateUsing, updateGridValues, undo, gotoDocList, save, style }} />
          </div>
          <br style={{ clear: 'both' }} />
        </div>
        <div className={style['sets-container']}>
          <div className={`${style['input-fields']} ${style.sets}`} style={{ float: 'left' }}>
            <InputSetting {...{ method, extendRange, style }} />
          </div>
          <div className={style.sets} style={{ float: 'right' }}>
            <CopySetting {...{ extendRange, style }} />
          </div>
          <br style={{ clear: 'both' }} />
        </div>
        <div className={`${style['sets-container']} ${style.sets} ${style['input-fields']}`}>
          <ScopeSetting {...{ updateScopeAndGridValues, style }} />
        </div>
        <div>
          <div style={{ width: 40 }} className={style.titleWord}>S</div>
          <div style={{ width: 30 }} className={style.titleWord}>C</div>
          {range(cMax + interval * 2, cMin + interval, interval * 2).map(c => (
            <div key={c} className={style.titleC} >{c / 100}</div>
          ))}
        </div>
      </div>
      <Grid {...{ scope, using, gridValues, ranges, updateUsing, clickCell, style }} />
    </div>
  )
}

RangeEditor.propTypes = {
  updateScopeAndGridValues: func.isRequired,
  updateUsing: func.isRequired,
  updateGridValues: func.isRequired,
  undo: func.isRequired,
  extendRange: func.isRequired,
  clickCell: func.isRequired,
  save: func.isRequired,

  page: shape({
    gotoDocList: func.isRequired,
  }).isRequired,
  ranges: array.isRequired,
  scope: shape({
    sMax: number.isRequired,
    sMin: number.isRequired,
    cMax: number.isRequired,
    cMin: number.isRequired,
    interval: number.isRequired,
  }).isRequired,
  gridValues: object.isRequired,
  using: shape({
    rangeKey: string.isRequired,
    method: string.isRequired,
  }).isRequired,
}

export default RangeEditor



// WEBPACK FOOTER //
// ./src/components/RangeEditor/RangeEditor.jsx